import React from 'react';
import { Quiz } from 'components';
import { QuizViewer } from 'components/QuizViewer';
import { PreassessmentModal } from '../components';
import { usePreassessmentContext } from '../contexts';
import { PreassessmentQuizLayout } from '../style';
import { useNotify } from 'ra-core';

const PreassessmentQuiz = () => {
  const notify = useNotify();
  const { quiz_token, quiz_id, gotoStartPage } = usePreassessmentContext();
  const [modalOpen, setModalOpen] = React.useState();

  return (
    <PreassessmentQuizLayout container alignItems={'center'} justifyContent={'center'}>
      <QuizViewer
        isPre={true}
        quizId={quiz_id}
        quizToken={quiz_token}
        onQuizEnd={() => setModalOpen(true)}
        onError={() => {
          // gotoStartPage();
          notify('Something went wrong. Please try again', 'warning');
        }}
        containerStyle={{
          width: '60rem'
        }}
      />
      <PreassessmentModal open={modalOpen} />
    </PreassessmentQuizLayout>
  );
};

export default PreassessmentQuiz;
